// components/PainelCerurb.js

import React from 'react';
import PainelRetratil from "./RatratilPainel";
import NucleoInfoCards from "./NucleoInfoCards";
import CerurbTable from "./CerurbTable";

const NoDataMessage = ({ message = "Nenhum dado a exibir para a seleção atual." }) => (
    <div style={{ padding: '15px', color: '#888', fontStyle: 'italic', fontSize: '14px' }}>
      {message}
    </div>
);

const estiloCardGeral = { backgroundColor: "#f5f5f5", padding: "8px", borderRadius: "6px", boxShadow: "0 1px 3px rgba(0,0,0,0.1)", minHeight: "50px" };
const estiloLabelGeral = { fontWeight: "bold", fontSize: "12px", color: "#4a5568", lineHeight: "1.2", marginBottom: "4px" };
const estiloValorGeral = { fontSize: "18px", fontWeight: "bold", color: "#2d3748" };

const DadosGeraisCards = ({ quantidadeNucleos, quantidadeMunicipios, totalVetorizados }) => (
  <div style={{
    display: "grid",
    gridTemplateColumns: "1fr 1fr 1fr",
    gap: "8px",
    maxWidth: 500,
  }}>
    <div style={estiloCardGeral}>
      <div style={estiloLabelGeral}>Núcleos</div>
      <div style={estiloValorGeral}>{quantidadeNucleos}</div>
    </div>
    <div style={estiloCardGeral}>
      <div style={estiloLabelGeral}>Municípios com Núcleos</div>
      <div style={estiloValorGeral}>{quantidadeMunicipios}</div>
    </div>
    <div style={estiloCardGeral}>
      <div style={estiloLabelGeral}>Total Vetorizados</div>
      <div style={estiloValorGeral}>{totalVetorizados}</div>
    </div>
  </div>
);

const PainelCerurb = ({
  loading,
  error,
  statusCounts,
  totalVetorizados,
  nucleosExternosFiltrados,
  selectedStatus,
  onStatusSelect,
}) => {

  if (loading) {
    return <p style={{ padding: '20px', textAlign: 'center' }}>Carregando dados...</p>;
  }

  if (error) {
    return <p style={{ padding: '20px', textAlign: 'center', color: 'red' }}>Erro ao carregar dados:  {error}</p>;
  }

  const quantidadeNucleos = nucleosExternosFiltrados?.length || 0;
  const quantidadeMunicipios = new Set(
    (nucleosExternosFiltrados || []).map(n => n.cidadeNucleo).filter(Boolean)
  ).size;
  const hasGeneralData = quantidadeNucleos > 0;
  const hasCardData = statusCounts && Object.keys(statusCounts).length > 0;


  return (
    <div style={{ display: "flex", flexDirection: "column"}}>
      <PainelRetratil titulo="Dados Gerais">{
        hasGeneralData ? (
          <div style={{ background: "#fff", padding: 10, borderRadius: "0px 0px 8px 8px", boxShadow: "0 2px 6px rgba(0,0,0,0.1)" }}>
            <DadosGeraisCards
              quantidadeNucleos={quantidadeNucleos}
              quantidadeMunicipios={quantidadeMunicipios}
              totalVetorizados={totalVetorizados || 0}
            />
          </div>
        ) : (
          <NoDataMessage />
        )
      }</PainelRetratil>

      <PainelRetratil titulo="Informações por status">{
        hasCardData ? (
          <div style={{ background: "#fff", padding: 10, borderRadius: "0px 0px 8px 8px", boxShadow: "0 2px 6px rgba(0,0,0,0.1)" }}>
            <p style={{ margin: "0 0 8px 0", fontSize: "10px", color: "#aaa", fontStyle: "italic" }}>
              clique em um status para filtrar os lotes no mapa
            </p>
            <NucleoInfoCards
              contagens={statusCounts}
              selectedStatus={selectedStatus}
              onStatusSelect={onStatusSelect}
            />
          </div>
        ) : (
          <NoDataMessage />
        )
      }</PainelRetratil>

      <PainelRetratil titulo="Dados (CERURB)">{
        nucleosExternosFiltrados && nucleosExternosFiltrados.length > 0 ? (
          <div style={{ background: "#fff", borderRadius: "0px 0px 8px 8px", boxShadow: "0 2px 6px rgba(0,0,0,0.1)" }}>
            <CerurbTable data={nucleosExternosFiltrados} />
          </div>
        ) : (
          <NoDataMessage message="Nenhum dado api CERURB para a seleção atual." />
        )
      }</PainelRetratil>
    </div>
  );
};

export default PainelCerurb;